






import { Component, Vue } from 'vue-property-decorator';
import FirmwaresForm from '@/components/FirmwaresForm.vue';

@Component({
  components: {
    FirmwaresForm,
  },
})
export default class Firmwares extends Vue {}
